import { ClaimEventSummary } from './ClaimEventSummary'
import { IProcessAction } from './ProcessAction'
import { ICMS1500Dto } from '../claim/Cms1500Dto'
import { MarkClaimAsAppealSummary } from './MarkClaimAsAppealSummary'
import { EmailLogRequest } from '../quotes/EmailLogRequest'
import { QuoteDTO } from '../quotes/QuoteDTO'
import { IApplyInvoicePaymentRequest } from '../ApplyInvoicePaymentRequest'
import { GlobalInvoiceDTO } from '../quotes/GlobalInvoiceDTO'
import { BilloutRequest } from './BilloutRequest'
import { ApplyPaymentRequest } from '../ApplyPaymentRequest'
import { AdditionalQuoteSummary } from './AdditionalQuoteSummary'
import { Combined1500Request } from './Combined1500Request'
import { ChronoCompleteRequest } from './ChronoCompleteRequest'
import { FinalizedRequest } from './FinalizedRequest'
import { RecordsReceivedRequest } from './RecordsReceivedRequest'
import { BackFromTranscriptionRequest } from './BackFromTranscriptionRequest'
import { RecordsReviewedRequest } from './RecordsReviewedRequest'
import { ReportSentRequest } from './ReportSentRequest'
import { DictatedRequest } from './DictatedRequest'
import { PatientInvoiceDetailDTO } from './PatientInvoiceDetailDTO'
import { MedicalPatientDTO } from './MedicalPatientDTO'
import { PaymentRequest } from '../PaymentRequest'
import { SelectDefaultCaseLineItemRequest } from './SelectDefaultCaseLineItemRequest'
import {
  ConsumerQuoteSaveRequest,
  CopyQuoteFromSourceRequest,
} from 'src/services/QuoteService'
import { SupplementalDocumentationDTO } from './SupplementalDocumentationDTO'

export interface IObjectiveProcessAction extends IProcessAction {
  comment: string | undefined
  assignUser: string | undefined
  assignDueDate: Date | undefined
  pendDate: Date | undefined
  pendNote: string | undefined
  claimEventData: ClaimEventSummary | undefined
  claimData: ICMS1500Dto | undefined
  markAppealData: MarkClaimAsAppealSummary | undefined
  sendToAdjusterData: EmailLogRequest | undefined
  quoteData: QuoteDTO | undefined
  InvoiceCheckData: IApplyInvoicePaymentRequest | undefined
  bundleDurationDays: number | undefined
  billOutData: BilloutRequest | undefined
  globalInvoiceData: GlobalInvoiceDTO | undefined
  billoutCheckData: ApplyPaymentRequest | undefined
  additionalQuoteData: AdditionalQuoteSummary | undefined
  combined1500Request: Combined1500Request | undefined
  chronoCompleteRequest: ChronoCompleteRequest | undefined
  finalizedRequest: FinalizedRequest | undefined
  recordsReceivedRequest: RecordsReceivedRequest | undefined
  dictatedRequest: DictatedRequest | undefined
  backFromTranscriptionRequest: BackFromTranscriptionRequest | undefined
  recordsReviewedRequest: RecordsReviewedRequest | undefined
  reportSentRequest: ReportSentRequest | undefined
  lineDetailRequest: PatientInvoiceDetailDTO | undefined
  casePatientRequest: MedicalPatientDTO | undefined
  casePaymentRequest: PaymentRequest | undefined
  processRefundData: ApplyPaymentRequest | undefined
  nextInboxIdOverride: number | undefined
  priorityOverride: number | undefined
  invoiceEmailHtmlBody: string | undefined
  selectDefaultCaseLineItemRequest: SelectDefaultCaseLineItemRequest | undefined
  invoiceSentDate: Date | undefined
  consumerQuoteSaveRequest: ConsumerQuoteSaveRequest | undefined
  copyQuoteFromSourceRequest: CopyQuoteFromSourceRequest | undefined
  supplementalDocumentationDTO: SupplementalDocumentationDTO | undefined
}

export class ObjectiveProcessAction implements IObjectiveProcessAction {
  public comment: string | undefined
  public assignUser: string | undefined
  public assignDueDate: Date | undefined
  public pendDate: Date | undefined
  public pendNote: string | undefined
  public claimEventData: ClaimEventSummary | undefined
  public claimData: ICMS1500Dto | undefined
  public markAppealData: MarkClaimAsAppealSummary | undefined
  public sendToAdjusterData: EmailLogRequest | undefined
  public quoteData: QuoteDTO | undefined
  public InvoiceCheckData: IApplyInvoicePaymentRequest | undefined
  public bundleDurationDays: number | undefined
  public billOutData: BilloutRequest | undefined
  public globalInvoiceData: GlobalInvoiceDTO | undefined
  public billoutCheckData: ApplyPaymentRequest | undefined
  public additionalQuoteData: AdditionalQuoteSummary | undefined
  public combined1500Request: Combined1500Request | undefined
  public chronoCompleteRequest: ChronoCompleteRequest | undefined
  public finalizedRequest: FinalizedRequest | undefined
  public recordsReceivedRequest: RecordsReceivedRequest | undefined
  public dictatedRequest: DictatedRequest | undefined
  public backFromTranscriptionRequest: BackFromTranscriptionRequest | undefined
  public recordsReviewedRequest: RecordsReviewedRequest | undefined
  public reportSentRequest: ReportSentRequest | undefined
  public lineDetailRequest: PatientInvoiceDetailDTO | undefined
  public casePatientRequest: MedicalPatientDTO | undefined
  public casePaymentRequest: PaymentRequest | undefined
  public processRefundData: ApplyPaymentRequest | undefined
  public nextInboxIdOverride: number | undefined
  public priorityOverride: number | undefined
  public invoiceEmailHtmlBody: string | undefined
  public selectDefaultCaseLineItemRequest: SelectDefaultCaseLineItemRequest | undefined
  public invoiceSentDate: Date | undefined
  public consumerQuoteSaveRequest: ConsumerQuoteSaveRequest | undefined
  public copyQuoteFromSourceRequest: CopyQuoteFromSourceRequest | undefined
  public supplementalDocumentationDTO: SupplementalDocumentationDTO | undefined
}
